export const plotTypes = {
  CONSTRUCTION: 'Baugrundstück',
  EXPECTED: 'Bauerwartungsland',
  BUSINESS: 'Gewerbegrundstück'

}
